import { CenterAlignedLoader } from '@medly-components/core';
import { GEAR_ROUTE } from 'constants/routes';
import { useActiveGears } from 'hooks/user';
import { GEARS } from 'pages/Gear/types';
import { FC, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * ActiveGearProtectedRoute responsible for checking wheather gear is active or not.
 */
export const ActiveGearProtectedRoute: FC<{ gear: string }> = ({ children, gear }) => {
    const { activeGears, isLoading } = useActiveGears();
    const navigate = useNavigate();

    useEffect(() => {
        if (isLoading) return;

        if (!activeGears.includes(gear as GEARS)) {
            navigate(GEAR_ROUTE);
        }
    }, [activeGears, isLoading]);

    if (isLoading) {
        return (
            <main>
                <CenterAlignedLoader />
            </main>
        );
    }

    return <>{children}</>;
};
